import { render, staticRenderFns } from "./fsyRadio.vue?vue&type=template&id=f6071892&scoped=true&"
import script from "./fsyRadio.vue?vue&type=script&lang=js&"
export * from "./fsyRadio.vue?vue&type=script&lang=js&"
import style0 from "./fsyRadio.vue?vue&type=style&index=0&id=f6071892&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6071892",
  null
  
)

export default component.exports